import React, { Component } from 'react';
import { QRCode } from 'react-qr-svg';
import AppStoreIcon from 'assets/auth/astore-small.png';
import PlayStoreIcon from 'assets/auth/gplay-small.png';
import PropTypes from 'prop-types';
import dhid from 'dhid';

import { FloatingModal } from '../../../components/Modal';
import Input from '../../../../Account/components/Input';
import buttonStyles from '../../../components/Button/button.scss';
import styles from './security.scss';

const propTypes = {
  show: PropTypes.bool,
  secret: PropTypes.string,
  id: PropTypes.number,
  errors: PropTypes.shape(),

  onVerifyClick: PropTypes.func,
  onModalClose: PropTypes.func,

  totp: PropTypes.bool,
};

class CreateGoogleModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
    };
  }

  render() {
    const {
      show, secret, id, errors, totp,
    } = this.props;
    const {
      name, code,
    } = this.state;

    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf('android') > -1;

    const type = totp ? 'totp' : 'hotp';

    return (
      <FloatingModal
        isOpen={show && !!secret}
        onRequestClose={() => this.props.onModalClose()}
        action={{
          onClick: () => this.props.onVerifyClick({ id, code, name }),
          text: 'Activate',
        }}
        buttonText="Cancel"
      >
        <div className={styles.modal}>
          <div className={styles.modalTitle}>Activate Google Authenticator</div>
          <div className={styles.modalMessage}>
            1. Download and install the Goole Authenticator app (or equivalent)
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{
                    marginTop: '10px',
                  }}
                  alt="Get it on Google Play"
                  src={PlayStoreIcon}
                />
              </a>
              <a // eslint-disable-line
                href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{
                    marginLeft: '10px',
                    marginTop: '10px',
                  }}
                  src={AppStoreIcon}
                  alt="Get it on Appstore"
                />
              </a>
            </div>
          </div>
          {!isAndroid && (
            <>
              <div className={styles.modalMessage} style={{ marginTop: '36px' }}>
                2. Scan the following QR code with the Google Authenticator app
              </div>
              <div className={styles.modalWhite}>
                <QRCode
                  bgColor="#ffffff"
                  fgColor="#1e1e20"
                  level="L"
                  style={{ width: 106 }}
                  value={`otpauth://${type}/${dhid.getUser().name}?secret=${secret}&issuer=DreamHack`}
                />
              </div>
            </>
          )}
          {isAndroid && (
            <>
              <div className={styles.modalMessage} style={{ marginTop: '36px' }}>
                2. Click on the button below to send the secret to the Authenticator app.
              </div>
              <div className={styles.modalMessage}>
                <a
                  href={`otpauth://${type}/${dhid.getUser().name}?secret=${secret}&issuer=DreamHack`}
                  className={buttonStyles.button}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    textDecoration: 'none',
                  }}
                >
                  Add to the Authenticator app
                </a>
              </div>
            </>
          )}
          <div className={styles.modalMessage} style={{ marginTop: '8px' }}>
            or add the following secret manually:
            {' '}
            <div
              className={styles.secret}
              style={{
                userSelect: 'all',
              }}
              dangerouslySetInnerHTML={{ // eslint-disable-line
                __html: secret && secret.replace(/\d/g, (match) => `<span>${match}</span>`),
              }}
            />
          </div>
          <div className={styles.modalMessage} style={{ marginTop: '36px' }}>
            3. Verify that everyting works by entering the current verification
            code shown in the app
          </div>
          <Input
            label={(
              <>
                Name
                {' '}
                <small>(something so you can identify your device)</small>
              </>
)}
            id="name"
            type="text"
            onChange={(event) => this.setState({ name: event.target.value })}
            value={name}
            errors={errors}
          />
          <Input
            label="Verification code"
            id="code"
            type="text"
            onChange={(event) => this.setState({ code: event.target.value })}
            value={code}
            errors={errors}
          />
        </div>
      </FloatingModal>
    );
  }
}

CreateGoogleModal.propTypes = propTypes;

export default CreateGoogleModal;
